import { getEnv } from './env';

export type Area = 'CN' | 'US';

export function getDefaultLocale() {
  return isChinese() ? 'zh-CN' : 'en-US';
}

// 判断当前版本是否为海外版
export const isGlobalVersion = () => {
  return getEnv('area') !== 'CN';
};

export const isChinese = () => {
  const area = getEnv('area');
  return ['CN'].includes(area);
};

/**
 * http://ip-api.com/json/
 * @param area
 * @returns
 */

export async function useCheckArea() {
  if (import.meta.server) {
    return;
  }

  const route = useRoute();
  const runtimeConfig = useRuntimeConfig();
  const { area, env } = runtimeConfig.public;

  if (
    !route.query.checkArea &&
    (route.query.allArea || sessionGetItem('allArea') || env !== 'production')
  ) {
    // 让开发和测试人员可以访问任意区域
    sessionSetItem('allArea', true);

    return;
  }

  if (area === 'US') {
    return;
  }

  try {
    const res = await $fetch<any>('https://pro.ip-api.com/json/?key=CCV4i9vC7OwDJ7K');

    if (res.countryCode === 'CN' && area !== 'CN') {
      // 中文地区只可以访问国内的

      location.href = `https://www.youyan3d.com/platform/${location.search}`;
      return;
    }

    if (res.countryCode !== 'CN' && area === 'CN') {
      location.href = `https://www.rendora.ai/platform/${location.search}`;
    }
  } catch (error) {
    console.log(error);
  }
}
